export default "/assets/e838d3be2375df75.png"